export default __webpack_public_path__ + "static/media/cd.8c272a00.png";